<template>
  <div class="product-container">
    <div class="banner">
      <img v-lazy="productAd" alt>
    </div>
    <div class="game-area content">
      <h2>精品手游</h2>
      <ul class="game-tab">
        <li
          v-for="(item,index) in gameTab"
          :class="{active:isActive==index}"
          @click="handelTab(index,item.tag)"
        >
          <span>{{item.name}}</span>
        </li>
      </ul>
      <div class="game-list" v-if="isShow">
        <transition-group name="flip-list" tag="ul" class="clearfix">
          <li v-for="(item,index) in gameList" :key="item.id">
            <a>
              <div class="img-block">
                <img class="game-img" :src="item.banner" alt>
                <div class="shade">
                  <img src="../assets/image/qrcode.png" alt>
                  <div class="desc">
                    <p>请扫描牛果游戏app</p>
                    <p>二维码下载游戏哦~</p>
                  </div>
                </div>
              </div>
              <div class="info">
                <div class="tit">{{item.app_name}}</div>
                <p>{{item.subtitle}}</p>
              </div>
            </a>
          </li>
        </transition-group>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isActive: 0,
      gaemTag: 101,
      page: 1,
      limit: 24,
      gameTab: [
        {
          name: "全部",
          tag: ""
        },
        {
          name: "角色",
          tag: "101"
        },
        {
          name: "策略",
          tag: "102"
        },
        {
          name: "卡牌",
          tag: "103"
        },
        {
          name: "其他",
          tag: "104"
        }
      ],
      gameList: [],
      productAd: "",
      isShow: false
    };
  },
  methods: {
    handelTab: function(index, tag) {
      if (this.isActive !== index) {
        this.isActive = index;
        this.getGameList(tag);
      }
    },
    getGameList: function(tag) {
      this.isShow = false;
      this.axios
        .get("/niuniu_api.php?action=tags", {
          params: {
            id: tag,
            page: this.page,
            limit: this.limit
          }
        })
        .then(response => {
          let res = response.data;
          if (res.errcode == 0) {
            this.isShow = true;
            this.gameList = res.data.tags;
          } else {
            console.log(res.errmsg);
          }
        });
    }
  },
  mounted: function() {
    //获取产品中心广告图
    this.axios.get("/niuniu_api.php?action=product").then(response => {
      let res = response.data;
      if (res.errcode == 0) {
        this.productAd = res.data[0].banner;
      } else {
        console.log(res.errmsg);
      }
    });
    this.getGameList(this.gaemTag);
  }
};
</script>

<style scoped>
.flip-list-move {
  transition: transform 0.8s;
}
.banner img {
  width: 100%;
}

.game-area {
  min-height: 800px;
}

.game-area h2 {
  font-size: 24px;
  color: #333;
  text-align: center;
  font-weight: bold;
  margin: 30px 0;
}

.game-area h2::before,
.game-area h2::after {
  content: "";
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE0AAAAECAMAAAD8gEImAAAAM1BMVEUAAACenp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp6enp7lJXpBAAAAEHRSTlMA4PCgIFDQwJBgMBCwQIBwKQNwDQAAAJFJREFUGNNVj1EOwCAIQwEVN3Xa+592RZMl+3ohpaXIU+sjIjnpTcilV+DW1InioxFteCF68hni9CNqovgPcEAjBUBmClEoEZGqQCUGYPQvAI12gsZuQJIvIEVAGOwbZJ3NhrNpZ7Ny7OciaxRinYtD5B9QzOLFprtMrxh9V/VMLNOyf7JJZKd9V60hTlM2/QW8ZScHUX0Sam4AAAAASUVORK5CYII=)
    no-repeat;
  width: 77px;
  height: 4px;
  display: inline-block;
  vertical-align: middle;
  margin: 0 15px;
}

.game-tab {
  margin: 0 0 10px -20px;
  overflow: hidden;
}

.game-tab li {
  width: 25%;
  float: left;
  padding-left: 20px;
  margin-bottom: 10px;
}
.game-tab li span {
  height: 40px;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  color: #333;
  display: block;
  border-radius: 4px;
  background-color: #f5f5f5;
  cursor: pointer;
  position: relative;
  transform: all 0.3s;
  z-index: 1;
  overflow: hidden;
}

.game-tab li.active span,
.game-tab li span:hover {
  color: #fff;
}

.game-tab li span::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #e23251;
  z-index: -1;
  opacity: 0;
  transform: scale3d(0.7, 1, 1);
  transition: transform 0.4s, opacity 0.4s;
  transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);
}

.game-tab li span:hover::before,
.game-tab li.active span::before {
  opacity: 1;
  transform: translate3d(0, 0, 0);
  color: #fff;
}

.game-list ul {
  padding-bottom: 40px;
  margin-top: -10px;
}

.game-list li {
  padding-top: 20px;
}

.game-list li a {
  display: block;
  border: 1px solid #ddd;
  box-shadow: 0px 1px 3px 0px rgba(221, 221, 221, 1);
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}

.game-list li a:hover {
  border: 1px solid #e23251;
}

.game-list .img-block {
  position: relative;
  overflow: hidden;
}
.game-list .game-img {
  width: 100%;
  display: block;
}

.game-list .shade {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  left: 0;
  top: -100%;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease-in-out;
}

.game-list li:hover {
  border-color: #e23251;
}

.game-list .shade img {
  width: 108px;
  height: 120px;
  display: block;
  position: absolute;
  top: 50%;
}

.game-list .shade .desc {
  position: absolute;
  top: 50%;
  margin-top: 30px;
}

.game-list .shade p {
  font-size: 20px;
  color: #fff;
  line-height: 40px;
}
.game-list .info {
  padding: 0 10px 5px;
}
.game-list .info .tit {
  line-height: 36px;
  font-size: 20px;
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-bottom: 1px solid #e1e1e1;
  margin-bottom: 5px;
}
.game-list .info p {
  font-size: 14px;
  color: #999;
  line-height: 26px;
  height: 26px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (min-width: 768px) {
}
@media (min-width: 992px) {
  .game-tab li {
    width: 118px;
  }
  .game-list {
    margin-left: -24px;
  }
  .game-list li {
    width: 33.3333%;
    float: left;
    padding-left: 24px;
  }

  .game-list li:hover .shade {
    top: 0;
    opacity: 1;
    visibility: visible;
  }
  .game-list .shade img {
    width: 90px;
    height: 100px;
    left: 20px;
    margin-top: -50px;
  }
  .game-list .shade p {
    font-size: 18px;
  }

  .game-list .shade .desc {
    position: absolute;
    top: 50%;
    left: 130px;
    margin-top: -38px;
  }
}
@media (min-width: 1200px) {
  .game-list .shade img {
    width: 108px;
    height: 120px;
    left: 30px;
    margin-top: -60px;
  }
  .game-list .shade .desc {
    position: absolute;
    top: 50%;
    left: 165px;
    margin-top: -38px;
  }
}
</style>